'use client';

import { c as _c } from "react/compiler-runtime";
import './tooltip-info.scss';
import React from 'react';
import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
import { IconNames } from '@sola/schema/lib/icons/icon-names.ts';
import { cn } from '../../utils/helpers.ts';
import { Tooltip, TooltipContent, TooltipContentProps, TooltipProps, TooltipTrigger } from '../tooltip/tooltip';
export interface TooltipInfoProps extends Pick<TooltipProps, 'isDefaultOpen' | 'isOpen' | 'onOpenChange'>, Omit<TooltipContentProps, 'children' | 'className'> {
  children: React.ReactNode;
  triggerLabel?: string;
  triggerClassName?: string;
  contentClassName?: string;
  iconName?: IconNames;
  iconSize?: string;
}
export const TooltipInfo = t0 => {
  const $ = _c(46);
  let align;
  let alignOffset;
  let children;
  let contentClassName;
  let fitContent;
  let iconSize;
  let isDefaultOpen;
  let isOpen;
  let onOpenChange;
  let props;
  let side;
  let sideOffset;
  let size;
  let t1;
  let t2;
  let triggerClassName;
  let usePortal;
  if ($[0] !== t0) {
    ({
      children,
      triggerLabel: t1,
      triggerClassName,
      contentClassName,
      iconName: t2,
      iconSize,
      isDefaultOpen,
      isOpen,
      onOpenChange,
      align,
      side,
      size,
      alignOffset,
      sideOffset,
      fitContent,
      usePortal,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = align;
    $[2] = alignOffset;
    $[3] = children;
    $[4] = contentClassName;
    $[5] = fitContent;
    $[6] = iconSize;
    $[7] = isDefaultOpen;
    $[8] = isOpen;
    $[9] = onOpenChange;
    $[10] = props;
    $[11] = side;
    $[12] = sideOffset;
    $[13] = size;
    $[14] = t1;
    $[15] = t2;
    $[16] = triggerClassName;
    $[17] = usePortal;
  } else {
    align = $[1];
    alignOffset = $[2];
    children = $[3];
    contentClassName = $[4];
    fitContent = $[5];
    iconSize = $[6];
    isDefaultOpen = $[7];
    isOpen = $[8];
    onOpenChange = $[9];
    props = $[10];
    side = $[11];
    sideOffset = $[12];
    size = $[13];
    t1 = $[14];
    t2 = $[15];
    triggerClassName = $[16];
    usePortal = $[17];
  }
  const triggerLabel = t1 === undefined ? "Additional information" : t1;
  const iconName = t2 === undefined ? "info-circle" : t2;
  let t3;
  if ($[18] !== triggerClassName) {
    t3 = cn("TooltipInfo", triggerClassName);
    $[18] = triggerClassName;
    $[19] = t3;
  } else {
    t3 = $[19];
  }
  let t4;
  if ($[20] !== iconSize) {
    t4 = iconSize ? {
      size: iconSize
    } : {};
    $[20] = iconSize;
    $[21] = t4;
  } else {
    t4 = $[21];
  }
  let t5;
  if ($[22] !== iconName || $[23] !== t4) {
    t5 = <ArkIcon iconName={iconName} {...t4} />;
    $[22] = iconName;
    $[23] = t4;
    $[24] = t5;
  } else {
    t5 = $[24];
  }
  let t6;
  if ($[25] !== t3 || $[26] !== t5 || $[27] !== triggerLabel) {
    t6 = <TooltipTrigger><button type="button" className={t3} aria-label={triggerLabel}>{t5}</button></TooltipTrigger>;
    $[25] = t3;
    $[26] = t5;
    $[27] = triggerLabel;
    $[28] = t6;
  } else {
    t6 = $[28];
  }
  let t7;
  if ($[29] !== align || $[30] !== alignOffset || $[31] !== children || $[32] !== contentClassName || $[33] !== fitContent || $[34] !== props || $[35] !== side || $[36] !== sideOffset || $[37] !== size || $[38] !== usePortal) {
    t7 = <TooltipContent {...props} align={align} side={side} size={size} alignOffset={alignOffset} sideOffset={sideOffset} fitContent={fitContent} usePortal={usePortal} className={contentClassName}>{children}</TooltipContent>;
    $[29] = align;
    $[30] = alignOffset;
    $[31] = children;
    $[32] = contentClassName;
    $[33] = fitContent;
    $[34] = props;
    $[35] = side;
    $[36] = sideOffset;
    $[37] = size;
    $[38] = usePortal;
    $[39] = t7;
  } else {
    t7 = $[39];
  }
  let t8;
  if ($[40] !== isDefaultOpen || $[41] !== isOpen || $[42] !== onOpenChange || $[43] !== t6 || $[44] !== t7) {
    t8 = <Tooltip isDefaultOpen={isDefaultOpen} isOpen={isOpen} onOpenChange={onOpenChange}>{t6}{t7}</Tooltip>;
    $[40] = isDefaultOpen;
    $[41] = isOpen;
    $[42] = onOpenChange;
    $[43] = t6;
    $[44] = t7;
    $[45] = t8;
  } else {
    t8 = $[45];
  }
  return t8;
};